import { fetchCustomerData } from 'src/store/customer/data/actions';
import { fetchCustomerDownloadTopics } from 'src/store/customer/downloads/actions';
import { fetchEntities } from 'src/store/entities/actions';
import { EntityDescriptions } from 'src/store/entities/types';
import { Projection } from 'src/store/entities/types/EntityDescription';
import { fetchMyOffers } from 'src/store/offer/action';
import { fetchShippingCostTable } from 'src/store/shipping-cost-table/actions';
import { fetchSuccessListTopics } from 'src/store/success-list/actions';
import { fetchVideoTopics } from 'src/store/video/actions';
import { SiteDefinition } from './SiteDefinition';

const CATALOG_BOOTSTRAP_MODULES = new Set(['store', 'services', 'about', 'contact', 'welcome']);
const USER_BOOTSTRAP_MODULES = new Set(['store', 'account', 'welcome']);
const PRIVILEGED_BOOTSTRAP_MODULES = new Set(['account']);

const includesAnyModule = (enabledModules: Set<string>, moduleSet: Set<string>): boolean => {
    for (const key of moduleSet) {
        if (enabledModules.has(key)) {
            return true;
        }
    }
    return false;
};

export const createModuleInit = (): NonNullable<SiteDefinition['init']> => ({ dispatch, runtime, enabledModules }) => {
    console.log('[moduleInit] modules:', [...enabledModules], '| loggedIn:', runtime.isLoggedIn);
    if (includesAnyModule(enabledModules, CATALOG_BOOTSTRAP_MODULES)) {
        console.log('[moduleInit] dispatching PRODUCT_GROUP fetch');
        dispatch(fetchEntities(EntityDescriptions.PRODUCT_GROUP, Projection.NONE));
        dispatch(fetchEntities(EntityDescriptions.VOLUME_DISCOUNT, Projection.NONE));
        dispatch(fetchShippingCostTable());
    }

    if (runtime.isLoggedIn && includesAnyModule(enabledModules, USER_BOOTSTRAP_MODULES)) {
        dispatch(fetchCustomerDownloadTopics());
        dispatch(fetchCustomerData());
        dispatch(fetchVideoTopics());
        dispatch(fetchMyOffers());
    }

    if (
        runtime.isLoggedIn &&
        runtime.hasPrivilege(['office_profi', 'partner', 'mlg']) &&
        includesAnyModule(enabledModules, PRIVILEGED_BOOTSTRAP_MODULES)
    ) {
        dispatch(fetchSuccessListTopics());
    }
};
